var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98 14.667a6.667 6.667 0 110-13.334 6.667 6.667 0 010 13.334z",
    stroke: "#403D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.827 7.04c0-1.387.98-1.953 2.18-1.26l.966.56.967.56c1.2.693 1.2 1.827 0 2.52l-.967.56-.966.56c-1.2.693-2.18.127-2.18-1.26V7.04z",
    stroke: "#A0A3BD"
  }))));
}

export default SvgPlayCircle;